/**
 * Regulatory and compliance frameworks applicable to CMDB components
 * Simplified for Norwegian context
 */
export var RegulatoryRequirement;
(function (RegulatoryRequirement) {
    // European & Norwegian Regulations (GDPR includes Personopplysningsloven)
    RegulatoryRequirement["GDPR"] = "gdpr";
    // Norwegian Regulations
    RegulatoryRequirement["ACCOUNTING_ACT"] = "accounting_act";
    RegulatoryRequirement["WORKING_ENVIRONMENT_ACT"] = "working_environment_act";
    RegulatoryRequirement["HEALTH_PERSONNEL_ACT"] = "health_personnel_act";
    // Financial Standards
    RegulatoryRequirement["PCI_DSS"] = "pci_dss";
    // Information Security Standards
    RegulatoryRequirement["ISO27001"] = "iso27001";
    // Aviation Specific
    RegulatoryRequirement["EASA_REGULATIONS"] = "easa_regulations";
    RegulatoryRequirement["AVIATION_SECURITY"] = "aviation_security";
    // Internal Policies
    RegulatoryRequirement["INTERNAL_POLICY"] = "internal_policy";
    RegulatoryRequirement["BEST_PRACTICES"] = "best_practices";
    // No specific requirements
    RegulatoryRequirement["NO_REQUIREMENTS"] = "no_requirements";
})(RegulatoryRequirement || (RegulatoryRequirement = {}));
/**
 * Valid regulatory requirement values for validation
 */
export const VALID_REGULATORY_REQUIREMENTS = Object.values(RegulatoryRequirement);
/**
 * Requirements that mandate encryption at rest
 */
export const ENCRYPTION_REQUIRED = [
    RegulatoryRequirement.GDPR,
    RegulatoryRequirement.PCI_DSS,
    RegulatoryRequirement.HEALTH_PERSONNEL_ACT,
    RegulatoryRequirement.ISO27001,
];
/**
 * Requirements that mandate audit logging
 */
export const AUDIT_LOG_REQUIRED = [
    RegulatoryRequirement.GDPR,
    RegulatoryRequirement.PCI_DSS,
    RegulatoryRequirement.ISO27001,
    RegulatoryRequirement.ACCOUNTING_ACT,
];
/**
 * Requirements specific to healthcare industry
 */
export const HEALTHCARE_REQUIREMENTS = [
    RegulatoryRequirement.HEALTH_PERSONNEL_ACT,
];
/**
 * Requirements specific to financial industry
 */
export const FINANCIAL_REQUIREMENTS = [
    RegulatoryRequirement.PCI_DSS,
    RegulatoryRequirement.ACCOUNTING_ACT,
];
